export default {
  strict: true,
  namespaced: true,
  state: {
    versions: new Map(),
  },
  getters: {
    getVersion: (state) => (id) => state.versions.get(id) || 1,
  },
  mutations: {
    updateVersion: (state, payload) => {
      var version = new Date().getTime();
      var changes = new Map([[payload, version]]);
      state.versions = new Map([...state.versions, ...changes]);
    },
  },
  actions: {
    updateVersion: (context, payload) => context.commit("updateVersion", payload),
  },
};
